var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offer"},[(_vm.isTruncated)?_c('span',[_vm._v(_vm._s(_vm.truncatedOffer))]):_c('span',[_vm._v(_vm._s(_vm.offer))]),(_vm.offer.length > 40)?_c('button',{on:{"click":_vm.toggleShowFull}},[_vm._v(" "+_vm._s(_vm.showFull ? "less" : "more")+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }